import { render, staticRenderFns } from "./Sonance.vue?vue&type=template&id=d28d880a&scoped=true"
import script from "./Sonance.vue?vue&type=script&lang=js"
export * from "./Sonance.vue?vue&type=script&lang=js"
import style0 from "./Sonance.vue?vue&type=style&index=0&id=d28d880a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d28d880a",
  null
  
)

export default component.exports